module.exports = __webpack_public_path__ + "static/img/brees-2004-img-in-copy.e4b42ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2004-img-in-copy.jpg
// module id = Fa3b
// module chunks = 1